import { render, staticRenderFns } from "./common-safe.vue?vue&type=template&id=9fa01fa0&scoped=true&"
import script from "./common-safe.vue?vue&type=script&lang=ts&"
export * from "./common-safe.vue?vue&type=script&lang=ts&"
import style0 from "./common-safe.vue?vue&type=style&index=0&id=9fa01fa0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa01fa0",
  null
  
)

export default component.exports